import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import es from 'vuetify/lib/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: {
    themes: {
      light: {
        primary: '#636569',
        secondary: '#fc5b00',
        PENDING: '#fc5b00',
        CANCELLED: '#848484',
        ACTIVE: '#1B5E20',
        FINISH: '#636569',
        INVOICED: '#636569',
        PLANNED: '#fc5b00',
        IN_PROGRESS: '#1565C0',
        EXECUTED: '#636569'
      }
    }
  }
})
